import { Component, Input, OnInit } from "@angular/core";
import {
  ControlContainer,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  FormGroupDirective,
  Validators,
} from "@angular/forms";

import { MatDialog } from "@angular/material/dialog";
import {
  faSortAmountDown,
  faSortAmountUp,
} from "@fortawesome/pro-light-svg-icons";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { faTrash } from "@fortawesome/pro-solid-svg-icons";
import { CanvasService } from "@services/canvas.service";
import { CommonService } from "@services/common.service";
import { faExclamationTriangle } from "@fortawesome/pro-light-svg-icons";
import { DateGroupOptionsComponent } from "@dialogs/date-group-options/date-group-options.component";
import { environment } from "@environments/environment";

@Component({
    selector: "app-grouping",
    templateUrl: "./grouping.component.html",
    styleUrls: ["./grouping.component.scss"],
    viewProviders: [
        { provide: ControlContainer, useExisting: FormGroupDirective },
    ],
    standalone: false
})
export class GroupingComponent implements OnInit {
  @Input() currentDataFields!: any;
  @Input() groupFields!: any;
  @Input() canvasOptions!: any;
  @Input() chartType!: any;

  childForm: any;
  faPlus = faPlus;
  faTrash = faTrash;
  faSortAmountUp = faSortAmountUp;
  faSortAmountDown = faSortAmountDown;
  public groupForm!: UntypedFormGroup;
  public aggregateData: any = [];
  public showDateFields: boolean = false;
  public groupId: any;
  public selectedId: any;
  public groupOptions: any = [];
  public editForm!: UntypedFormGroup;
  public featureFlags: any = [];
  public option: any = "M";
  public showGrouping = false;

  constructor(
    public parentF: FormGroupDirective,
    private fb: UntypedFormBuilder,
    private canvasService: CanvasService,
    public commonService: CommonService,
    public dialog: MatDialog
  ) {}
  faExclamationTriangle = faExclamationTriangle;

  buildAggregateData(id?: any) {
    this.aggregateData = [];
    if (!id) id = this.selectedId;

    const data = {
      dataPointId: id,
      modifiers: [{ id: this.groupId, value: "" }],
    };
    this.aggregateData.push(data);

    this.childForm.get("groupdata")!.setValue(this.aggregateData);

    // make refresh call and emit the chart data to the parent
    this.canvasService.refreshCanvas(this.childForm).subscribe(
      (success: any) => {
        this.canvasService.triggerEnable();
        const data = success.data;
        this.canvasService.pushChartToStorage(data);
        this.canvasService.populateCanvas(data);
      },
      (error: any) => {
        this.canvasService.triggerEnable();
        const data = this.canvasService.getChartFromStorage();
        this.canvasService.populateCanvas(data);
      }
    );
  }

  buildAggregateDataWithEvent(event: any) {
    this.aggregateData = [];

    const data = {
      dataPointId: event.value,
      modifiers: [{ id: this.groupId, value: "" }],
    };
    this.aggregateData.push(data);

    this.childForm.get("groupdata")!.setValue(this.aggregateData);

    // make refresh call and emit the chart data to the parent
    this.canvasService.refreshCanvas(this.childForm).subscribe(
      (success: any) => {
        this.canvasService.triggerEnable();
        const data = success.data;
        this.canvasService.pushChartToStorage(data);
        this.canvasService.populateCanvas(data);
      },
      (error: any) => {
        this.canvasService.triggerEnable();
        const data = this.canvasService.getChartFromStorage();
        this.canvasService.populateCanvas(data);
      }
    );
  }

  isGroupOptionDisabled(opt: any): boolean {
    return (
      this.groupForm.get("fields")!.value &&
      this.groupForm.get("fields")!.value.length >= 1 &&
      !this.groupForm.get("fields")!.value.find((el: any) => el == opt)
    );
  }
  initForm() {
    this.groupForm = this.fb.group({
      fields: new UntypedFormControl(),
    });
  }
  generateQuantifiers() {
    let generatedData: any[] = [];
    this.groupFields.forEach((element: any) => {
      generatedData.push(element.dataPoint.data.id);
    });
    this.groupForm.get("fields")!.setValue(generatedData[0]);
  }
  selectSubGrouping(type: any, name?: any, id?: any) {
    if (type == "date") {
      this.showGrouping = true;
      this.childForm.get("isDateGroupRange")!.setValue(true);

      // const groupDateRange = this.childForm.get("groupDateRange")!.value;
      // if (groupDateRange == "")
      //   this.childForm.get("groupDateRange")!.setValue("M");

      if (this.editForm && !this.editForm.get("range")!.value)
        this.editForm.get("range")!.setValue("");
    } else {
      this.childForm.get("isDateGroupRange")!.setValue(false);
      this.showGrouping = false;
      // if (this.childForm) this.childForm.get("groupDateRange")!.setValue(null);
    }
    if (id) this.selectedId = id;
  }

  currentDateRange(type: any) {
    let rangeText = "";
    const range = this.childForm.get("groupDateRange")!.value;

    if (type == "date") {
      rangeText = " (";
      switch (range) {
        case "D":
          rangeText += "Day";
          this.showGrouping = true;
          break;
        case "M":
          rangeText += "Month";
          this.showGrouping = true;
          break;
        case "Q":
          rangeText += "Quarter";
          this.showGrouping = true;
          break;
        case "Y":
          rangeText += "Year";
          this.showGrouping = true;
          break;
      }
      rangeText += ")";
      if (!range || range == "") {
        rangeText = "";
        this.showGrouping = false;
      }
    }
    return rangeText;
  }
  applyChange() {
    this.childForm
      .get("groupDateRange")!
      .setValue(this.editForm.get("range")!.value);
    this.buildAggregateData();
  }
  ngOnChanges() {
    this.childForm = this.parentF.form;

    this.showDateFields = false;
    if (this.groupFields) {
      this.groupFields = this.groupFields;
      this.showDateFields = false;
    }
    this.groupOptions = this.canvasOptions.groupOptions;

    if (this.groupOptions && this.groupOptions.data) {
      this.groupId = this.groupOptions.data[0].id;
    }
    if (this.groupForm) {
      if (this.groupFields && this.groupFields.length > 0) {
        this.generateQuantifiers();
      }
    }

    if (this.groupFields[0])
      this.selectSubGrouping(
        this.groupFields[0].dataPoint.data.type,
        this.groupFields[0].dataPoint.data.name,
        this.groupFields[0].dataPoint.data.id
      );

    if (this.editForm && this.childForm) {
      this.editForm
        .get("range")!
        .setValue(this.childForm.get("groupDateRange")!.value);
    }
  }
  ngOnInit(): void {
    this.childForm = this.parentF.form;
    if (this.childForm) {
      this.editForm = this.fb.group({
        range: [
          this.childForm.get("groupDateRange")!.value,
          Validators.required,
        ],
      });
    }
    if (this.canvasOptions && this.canvasOptions.groupOptions) {
      this.groupOptions = this.canvasOptions.groupOptions;
    }
    if (this.groupOptions && this.groupOptions.length > 0) {
      this.groupId = this.groupOptions.data[0].id;
    }
    this.initForm();

    if (this.groupFields && this.groupFields.length > 0) {
      this.generateQuantifiers();
    }
  }
}
